import { t, type I18nLocale } from '@ardoq/i18n';

export const NO_MESSAGE = '';

export const getCrossWorkspaceEditMessage = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:disabledMessages.crossWorkspace',
    'Cannot edit across workspaces'
  );

export const getCalculatedFieldEditMessage = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:disabledMessages.calculated',
    'Calculated field data is read-only.'
  );

export const getLocallyDerivedFieldEditMessage = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:disabledMessages.locallyDerived',
    'Reactive fields are read-only.'
  );

export const getManagedFieldEditMessage = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:disabledMessages.managed',
    'This data is managed externally and editing is restricted'
  );

export const getLockedMessageText = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:disabledMessages.locked',
    'Some of the components or references being edited are locked.'
  );

export const GENERIC_FORM_ERROR_MESSAGE = 'An error occurred.';
export const COMPONENT_CREATED_MESSAGE = 'Component created.';

export const getConfidentialFieldEditMessage = (i18nLocale: I18nLocale) =>
  t(
    i18nLocale,
    'propertiesEditor:disabledMessages.confidential',
    'You do not have permission to view or edit this field.'
  );
